import { useTheme } from "../../contexts/ThemeContext"

interface LoadingSpinnerProps {
  color?: string
  size?: "sm" | "md" | "lg"
}

export default function LoadingSpinner({ color, size = "md" }: LoadingSpinnerProps) {
  const { primaryColor } = useTheme()
  const effectiveColor = color || primaryColor || "#C44536"
  
  const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-12 w-12",
    lg: "h-16 w-16",
  }

  return (
    <div className="flex items-center justify-center">
      <div
        className={`animate-spin rounded-full border-t-2 border-b-2 ${sizeClasses[size]}`}
        style={{ borderColor: effectiveColor }}
      ></div>
    </div>
  )
}
